import { FlightIngredient } from '@apps/main/modules/recipe/ingredients';
import type { FlightIngredientFilters } from '@apps/main/modules/recipe/ingredients/flightIngredient';

import { safelyDeserializeFilter } from '../helpers';
import {
  deserializeAvailabilityOrder,
  deserializeIngredientParameters,
  deserializePorts,
  deserializeTransportFilters,
} from '../deserializeTransport';

import { FLIGHT_INGREDIENT_SUFFIX } from './constants';

export function deserializeFlight(value: string): FlightIngredient {
  const flight = new FlightIngredient();
  flight.isConfirmed = true;
  const serializedFlight = value.slice(0, -FLIGHT_INGREDIENT_SUFFIX.length);

  const {
    serializedPorts,
    transportIds,
    serializedProps,
    serializedAvailabilityOrder,
  } = deserializeIngredientParameters(serializedFlight);

  const { fromPort, toPort } = deserializePorts(serializedPorts);

  flight.fromPort = fromPort;
  flight.toPort = toPort;

  flight.transportIds = transportIds;

  const { filters } = deserializeFlightProps(serializedProps);

  flight.filters = filters;

  flight.availabilityOrder = deserializeAvailabilityOrder(
    serializedAvailabilityOrder
  );

  return flight;
}

function deserializeFlightProps(serializedProps: string[]): {
  filters: FlightIngredientFilters;
} {
  const flightFilters = FlightIngredient.defaultFilters;

  flightFilters.maxNumberOfStops = safelyDeserializeFilter(
    serializedProps[0],
    (value) => Number(value)
  );

  const transportFilters = deserializeTransportFilters(
    serializedProps.slice(1)
  );

  return {
    filters: { ...flightFilters, ...transportFilters },
  };
}
